export interface registerItem {
  name: string;
  type: string;
  value?: string;
  defaultValue?: any;
  isValid: boolean;
  validCondition?: RegExp | number;
  errorMsg: string;
  errorRegex?: RegExp;

}

const registerItems: registerItem[] = [
  {
    name: "Nom",
    type: "text",
    isValid: false,
    validCondition: /^.{1,}$/,
    errorMsg: "Votre nom est trop court !",
  },
  {
    name: "Prénom",
    type: "text",
    isValid: false,
    validCondition: /^.{1,}$/,
    errorMsg: "Votre prénom est trop court !",
  },
  {
    name: "Email",
    type: "email",
    isValid: false,
    validCondition:
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    errorMsg: "Veuillez entrez un email valide !",
  },
  {
    name: "Téléphone",
    type: "tel",
    isValid: false,
    validCondition: /^.{10,}$/,
    errorMsg: "Veuillez entrez un numéro de 10 chiffres au moins !",
  },
  {
    name: "Mot de passe",
    type: "password",
    isValid: false,
    validCondition: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}$/,
    errorMsg:
      "Veuillez entrez un mot de passe de 8 caractères avec une majuscule, une minuscule et un chiffre au moins !",
  },
  {
    name: "Confirmez le mot de passe",
    type: "password",
    isValid: false,
    validCondition: -1,
    errorMsg: "Veuillez entrez le même mot de passe !",
  },
  {
    name: "Durée de formation",
    type: "select",
    defaultValue: [
      { display: "6 mois", value: "6" },
      { display: "12 mois", value: "12" },
      { display: "24 mois", value: "24" },
      { display: "36 mois", value: "36" },
    ],
    isValid: false,
    validCondition: /^.{1,}$/,
    errorMsg: "Choississez une durée de formation",
  },
];

export default registerItems;
